import { CollisionGroupManager, CollisionGroup } from "excalibur";

/**
 * Collision Groups for Riley vs Virus
 * 
 * For two actors to collide, each must include the other's group in its mask.
 * 
 * Groups:
 * - PlayerGroup: The Macrophage (player character)
 * - EnemyGroup: Viruses (enemies that swarm)
 * - WallGroup: World boundaries (stop player only)
 * - ProjectileGroup: Antibodies (damage enemies, don't push)
 * - ItemGroup: Antigens/XP gems (collected by walking over)
 * 
 * Rules:
 * - Macrophage (Active): Collides with Walls, Enemies, Items
 * - Viruses (Active): Collide with Player, other Enemies (swarming), Projectiles
 * - Walls (Fixed): Block Player only (enemies pass through)
 * - Antibodies (Passive): Trigger on Enemies (no physics push)
 * - Antigens (Passive): Trigger on Player (collectible items)
 */

// Base category groups
// Base category groups (Identities)
export const WallGroup = CollisionGroupManager.create('wall');
export const PlayerGroup = CollisionGroupManager.create('player');
export const EnemyGroup = CollisionGroupManager.create('enemy');
export const ProjectileGroup = CollisionGroupManager.create('projectile');
export const ItemGroup = CollisionGroupManager.create('item');

// Configure Masks
// Helper to extract category because referencing .category directly might be safe
// If .category is private, we might be in trouble, but usually it's public readonly in v0.32

// Macrophage: IS Player, HITS Wall | Enemy | Item
export const MacrophageCollision = new CollisionGroup(
    'macrophage',
    PlayerGroup.category,
    WallGroup.category | EnemyGroup.category | ItemGroup.category | PlayerGroup.category
);

// Viruses: IS Enemy, HITS Player | Enemy | Projectile
export const VirusCollision = new CollisionGroup(
    'virus',
    EnemyGroup.category,
    PlayerGroup.category | EnemyGroup.category | ProjectileGroup.category
);

// Walls: IS Wall, HITS Player
export const WallCollision = new CollisionGroup(
    'wall',
    WallGroup.category,
    PlayerGroup.category | WallGroup.category
);

// Antibodies: IS Projectile, HITS Enemy
export const ProjectileCollision = new CollisionGroup(
    'projectile',
    ProjectileGroup.category,
    EnemyGroup.category | ProjectileGroup.category
);

// Antigens/Items: IS Item, HITS Player
export const ItemCollision = new CollisionGroup(
    'item',
    ItemGroup.category,
    PlayerGroup.category | ItemGroup.category
);
